// Dev environment for Share variant — ECS deployment
export const environment = {
  production: true,
  apiUrl: 'https://api.omni.dev.barkani.com',
  companyId: 'cmp_8048562',
  variant: 'share',
  title: 'Share',
  features: {
    callPlan: false
  },
  routes: {
    thankYou: '/thank-you'
  }
};
